module.exports = __webpack_public_path__ + "static/media/bannerL.90a8ab6b.png";